/* eslint-disable no-useless-computed-key */
let initialState = {
    selectProfileFilterValue: {
      global_dashboard: { data: null },
      dashboard_section: { data: null },
      dashboard_widget: { data: null },
      template_global: { data: null },
      template_section: { data: null },
      template_widget: { data: null },
      graph_page: { data: null },
      orm_dashboard: { data: null },
      share_modal: { data: null },
      widgetMaker: { data: null },
      advance_settings: { data: null },
      preview: { data: null },
    },
    profileFilterCheckedItems: {
      global_dashboard: { data: { } },
      dashboard_section: { data: { } },
      dashboard_widget: { data: { } },
      template_global: { data: { } },
      template_section: { data: { } },
      template_widget: { data: { } },
      graph_page: { data: { } },
      orm_dashboard: { data: { } },
      share_modal: { data: { } },
      widgetMaker: { data: { } },
      advance_settings: { data: { } },
      preview: { data: { } },
    },
    previewBrands: null,
  };
  const ProfileFilter = (state = initialState, action) => {
    switch (action.type) {
      case "SET_SELECT_PROFILE_FILTER_VALUE":
        return {
          ...state,
          selectProfileFilterValue: action.payload,
        };
      case "SET_PROFILE_FILTER_CHECKED_ITEMS":
        return {
          ...state,
          profileFilterCheckedItems: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default ProfileFilter;
  